<template>
	<div class="view-index-v">
		<div class="echart-wrapper">
			<div ref="echart" class="echart"></div>
		</div>
		<div class="project-list">
			<div class="project-item" v-for="(item, idx) in listData" :key="idx" @click="onClickItem(item.id)">
				<div class="project-main">
					<img :src="item.coverImgUrl" class="project-img" />
					<div class="inf-container">
						<div class="name single-line">项目名称:{{item.projectName}}</div>
						<div class="location single-line">项目位置:{{getProjectLocation(item)}}</div>
					</div>
				</div>
			</div>
		</div>
		<div class="pop-list" :style="popListStyle" @mousemove="onHoldPopList"  @mouseleave="onChartUnPopList">
			<img class="bg" :style="popBgStyle" src="~@/assets/png/pop-bg.png" />
			<div class="list-wrapper">
				<div class="item-wrapper" v-for="(item, idx) in popListItems" :key="idx"  @click="onClickItem(item.id)">
					<img :src="item.coverImgUrl" class="project-img" />
					<div class="inf-container">
						<div class="name single-line">项目名称:{{item.projectName}}</div>
						<div class="location single-line">项目位置:{{getProjectLocation(item)}}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import IndexMixin from './mixins/index.js';
	export default {
		name: 'IndexV',
		mixins: [IndexMixin],
		data() {
			return {
				
			}
		},
		mounted() {
			
		},
		methods: {
			
		}
	}
</script>

<style scoped lang="less">
	.view-index-v {
		width: 100%;
		padding: calc(50px * var(--scale-rate)) calc(52px * var(--scale-rate)) 0;
		position: relative;
		
		.echart-wrapper {
			width: 100%;
			height: 0;
			padding-top: 50%;
			position: relative;
			overflow: hidden;
			.echart {
				width: 100%;
				height: 100%;
				top: 0;
				left: 0;
				position: absolute;
			}
		}
		
		.project-list {
			width: 100%;
			display: flex;
			flex-wrap: wrap;
			justify-content: flex-start;
			margin-top: calc(62px * var(--scale-rate));
			
			.project-item {
				width: 50%;
				padding: calc(20px * var(--scale-rate)) calc(20px * var(--scale-rate));
				cursor: pointer;
				&:nth-of-type(odd) {
					padding-left: 0;
				}
				&:nth-of-type(even) {
					padding-right: 0;
				}
				
				.project-main {
					width: 100%;
					height: 0;
					padding-top: 66.6666667%;
					position: relative;
					
					.project-img {
						position: absolute;
						top: 0;
						height: 0;
						width: 100%;
						height: 100%;
						object-fit: fill;
					}
					.inf-container {
						width: calc(100% / var(--scale-rate));
						height: 78px;
						background-color: rgba(58, 58, 61, 0.58);
						position: absolute;
						bottom: calc(8px * var(--scale-rate));
						color: #FFFFFF;
						transform: scale(var(--scale-rate));
						transform-origin: 0 100%;
						padding-left: 26px;
						display: flex;
						flex-direction: column;
						justify-content: center;
						align-items: flex-start;
						.name {
							font-size: 23px;
							width: 100%;
						}
						.location {
							font-size: 23px;
							width: 100%;
						}
					}
				}
			}
		}
		
		.pop-list {
			width: calc(264px * var(--scale-rate)); 
			padding: calc(49px * var(--scale-rate)) calc(14px * var(--scale-rate)) calc(14px * var(--scale-rate));
			border-bottom-right-radius: calc(14px * var(--scale-rate));
			border-bottom-left-radius: calc(14px * var(--scale-rate));
			.bg {
				height: calc(387px * var(--scale-rate));
			}
			.list-wrapper {
				max-height: calc((387px - 49px - 14px) * var(--scale-rate));
				.item-wrapper {
					margin-bottom: calc(7px * var(--scale-rate));
					.inf-container {
						height: 45px;
						bottom: calc(5.6px * var(--scale-rate));
						padding-left: 14px;
						.name {
							font-size: 17px;
						}
						.location {
							font-size: 17px;
						}
					}
				}
			}
		}
	}
</style>